export default __webpack_public_path__ + "static/media/Group9417.bce89b85.svg";